export default __webpack_public_path__ + "static/media/plaine-commune_picture.06c3dfbf.jpg";